import React, { Fragment } from "react";
import { Link } from "react-scroll";
import { Link as RouterLink } from "react-router-dom";

const doctorDeptListBangalore = [
  {
    id: 1,
    deptTitle: "Obstetrics & Gynaecology",
    dept: "obstetrics_and_gynecology",
  },
  {
    id: 16,
    deptTitle: "Paediatrics & Neonatologist",
    dept: "paediatrics_and_neonatologist",
  },
  {
    id: 2,
    dept: "paediatrics_and_subspeciatilies",
    deptTitle: "Paediatric Subspecialities",
  },
  {
    id: 3,
    deptTitle: "Developmental Paediatrics",
    dept: "developmental_pediatrics",
  },
  {
    id: 5,
    deptTitle: "Radiology & Fetal Medicine",
    dept: "fetal_medicine",
  },
  {
    id: 4,
    deptTitle: "Anaesthesia & Critical Care",
    dept: "anaesthesia_and_critical_care",
  },

  // {
  //   id: 6,
  //   deptTitle: "Endocrinology And Diabetology",
  //   dept: "endocrinology_and_diabetology",
  // },
  {
    id: 8,
    deptTitle: "Physicians",
    dept: "physicians",
  },
  // {
  //   id: 7,
  //   deptTitle: "Specialists for Psychiatric & psychological counseling",
  //   dept: "specialists_for_mind_care",
  // },

  {
    id: 9,
    deptTitle: "Surgical Speciality",
    dept: "surgical_specialist",
  },
  // {
  //   id: 10,
  //   deptTitle: "Cosmetologist and Plastic Surgery",
  //   dept: "cosmetologists_and_plastic_surgeons",
  // },
  // {
  //   id: 11,
  //   deptTitle: "Cosmetic Gynecology And Aesthetic Gynecology",
  //   dept: "cosmetic_gynecology_and_aesthetic_gynecology",
  // },
  // {
  //   id: 12,
  //   deptTitle: "Fertility & IVF",
  //   dept: "infertility-and-ivf",
  // },
  {
    id: 13,
    deptTitle: "Dental",
    dept: "dental",
    link: "/doctors/dentistry",
  },
  // {
  //   id: 14,
  //   deptTitle: "Ultrasound and Radiology",
  //   dept: "ultrasound_and_radiology",
  // },
  {
    id: 15,
    deptTitle: "Other Specialities",
    dept: "other_specialities",
  },
];
const DeptList = ({ onSetActiveFunc }) => {
  const [deptList, setDeptList] = React.useState(doctorDeptListBangalore);

  return (
    <Fragment>
      <br />
      <div className="container">
        <div className="row deptListDiv">
          {deptList.map((deptData) => (
            <div key={deptData.id} className="col-sm-4 cardComp">
              {/* 👉 If link exists, use RouterLink (page navigation).
                  Otherwise, use ScrollLink (smooth scroll). */}
              {deptData.link ? (
                <RouterLink to={deptData.link}>
                  <div className="card cardStyle">
                    <div className="card-body">
                      <h5 className="card-title cardTitle">
                        {deptData.deptTitle}
                      </h5>
                    </div>
                  </div>
                </RouterLink>
              ) : (
                <Link
                  activeclassname="active"
                  to={deptData.dept}
                  spy={true}
                  smooth={true}
                  duration={1000}
                  delay={500}
                  offset={-300}
                  onSetActive={onSetActiveFunc}
                >
                  <div className="card cardStyle">
                    <div className="card-body">
                      <h5 className="card-title cardTitle">
                        {deptData.deptTitle}
                      </h5>
                    </div>
                  </div>
                </Link>
              )}
            </div>
          ))}
        </div>
      </div>
      <br />
    </Fragment>
  );
};

export default DeptList;
export { doctorDeptListBangalore };
